import React from 'react';
import Spline from '@splinetool/react-spline';
import { Button } from '../components/ui/button';
import { ArrowRight, Play } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative min-h-screen bg-black pt-20 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-[7.6923%] py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="z-10">
            <h1 className="text-[66px] font-semibold leading-[1.1] tracking-[-0.62px] text-white mb-6">
              Farm, Earn & Own on the Blockchain
            </h1>
            <p className="text-[20px] font-medium leading-[1.5] text-[rgba(255,255,255,0.85)] mb-10">
              Build your crypto farming empire on Pio blockchain. Grow crops, raise animals, and earn real tokens. Your farm, your assets, your profits.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 mb-10">
              <div className="border border-[rgba(255,255,255,0.25)] p-6 bg-[rgba(255,255,255,0.05)]">
                <div className="text-[32px] font-semibold text-[#00FFD1]">50,000+</div>
                <div className="text-[16px] text-[#4D4D4D]">Active Players</div>
              </div>
              <div className="border border-[rgba(255,255,255,0.25)] p-6 bg-[rgba(255,255,255,0.05)]">
                <div className="text-[32px] font-semibold text-[#00FFD1]">$225M+</div>
                <div className="text-[16px] text-[#4D4D4D]">Total Value Locked</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-wrap gap-4">
              <Button className="bg-[#00FFD1] text-black hover:bg-[rgba(0,255,209,0.8)] border-0 rounded-none h-14 px-6 text-lg font-medium flex items-center gap-3">
                Start Farming
                <ArrowRight className="w-5 h-5" />
              </Button>
              <Button className="bg-[rgba(255,255,255,0.1)] text-white hover:bg-white hover:text-black border-0 rounded-none h-14 px-6 text-lg font-medium flex items-center gap-3">
                <Play className="w-5 h-5" />
                Watch Demo
              </Button>
            </div>
          </div>

          {/* Right 3D Spline */}
          <div className="relative h-[700px] w-full overflow-visible">
            <div className="absolute inset-0">
              <Spline
                scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode"
                style={{ width: '100%', height: '100%' }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Background Pattern Overlay */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-[0.14]"
        style={{
          backgroundImage: `
            repeating-linear-gradient(0deg, transparent, transparent 1px, transparent 1px, transparent 7.6923%),
            repeating-linear-gradient(-90deg, #fff, #fff 1px, transparent 1px, transparent 7.6923%)
          `,
          backgroundSize: '100% 100%'
        }}
      />
    </section>
  );
};

export default Hero;
